<template>
  <div class="home">
    <!--img alt="Vue logo" src="../assets/logo.png" /-->
    <MusicComponent msg="音楽にようこそ" />
  </div>
</template>

<script>
// @ is an alias to /src
import MusicComponent from "@/components/MusicComponent.vue";

export default {
  name: "Music",
  components: {
    MusicComponent
  }
};
</script>
